import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import MultilingualField from '../components/MultilingualField';
import '../components/AdminUI.css';

export default function SEO() {
  const [pages, setPages] = useState([]);
  const load = () => axios.get('/pages').then((r) => setPages(r.data));
  useEffect(() => { load(); }, []);

  const update = (i, patch) => setPages(pages.map((p, j) => j === i ? { ...p, ...patch } : p));

  const save = async (p) => {
    await axios.put(`/pages/${p.id}`, { i18n: p.i18n, og_image: p.og_image, canonical_url: p.canonical_url, noindex: !!p.noindex });
  };

  return (
    <div className="admin-page">
      {pages.map((p, i) => (
        <div className="admin-card" key={p.id}>
          <h3 style={{ marginTop: 0 }}>{p.page_slug}</h3>
          <MultilingualField value={p.i18n || {}} fields={['title', 'description']} multiline={['description']} onChange={(v) => update(i, { i18n: v })} />
          <div className="admin-grid admin-grid-2">
            <div><label className="admin-label">OG image</label><input className="admin-input" value={p.og_image || ''} onChange={(e) => update(i, { og_image: e.target.value })} /></div>
            <div><label className="admin-label">Canonical URL</label><input className="admin-input" value={p.canonical_url || ''} onChange={(e) => update(i, { canonical_url: e.target.value })} /></div>
            <div><label style={{ display: 'flex', gap: 6 }}><input type="checkbox" checked={!!p.noindex} onChange={(e) => update(i, { noindex: e.target.checked })} /> noindex</label></div>
          </div>
          <button className="admin-btn admin-btn-gold" onClick={() => save(p)}>Enregistrer</button>
        </div>
      ))}
    </div>
  );
}
